"use strict";

angular.module("exploitation")

	.controller("OpenImportsCtrlFlexDetails", ["$scope", "$controller", "$route", "flexJob",
		function ($scope, $controller, $route, flexJob) {

		$controller("JobsCtrlParent", {$scope: $scope});

		$scope.data = {
			referential: $route.current.params.referential,
			job: flexJob.data,
			statsEntries: []
		};

		let stats = $scope.data.job.report && $scope.data.job.report.stats;
		if (stats) {
			$scope.data.statsEntries = Object.keys(stats).map(key => ({label: key, value: stats[key]}));
		}

		$scope.data.startedDate = $scope.data.job.started != null ? new Date($scope.data.job.started * 1000) : null;
		$scope.data.finishedDate = $scope.data.job.finished != null ? new Date($scope.data.job.finished * 1000) : null;

	}]);
